import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import CsQnaDetailContainer from '../../../containers/cs/qna/CsQnaDetailContainer';
import { CS_QNA_PAGE_NAME } from '../../../constants/service/app/csQnaConstants';

const CsQnaDetail = () => {
  return (
    <PageTemplate pageName={CS_QNA_PAGE_NAME.QNA_DETAIL}>
      <CsQnaDetailContainer />
    </PageTemplate>
  );
};

export default CsQnaDetail;
